/* iter55g15 — Spell-check (Claude) hook.
 *
 * Wraps the POST /api/projects/{pid}/spellcheck flow, its loading flag,
 * the returned issues list, and the drawer-open trigger. Extracted from
 * EditorPanel.jsx so the panel only has to render the drawer, not
 * orchestrate the network call.
 */
import { useCallback, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function useSpellCheck({ project, chapter, isDemo, recordLock }) {
  const [spellChecking, setSpellChecking] = useState(false);
  const [spellIssues,   setSpellIssues]   = useState([]);
  const [spellOpen,     setSpellOpen]     = useState(false);

  const runSpellCheck = useCallback(async () => {
    if (!project || !chapter) return;
    if (isDemo) { recordLock?.('Spell-check'); return; }
    setSpellChecking(true);
    try {
      const { data } = await axios.post(
        `${API}/projects/${project.id}/spellcheck`,
        { chapter_id: chapter.id },
        { withCredentials: true, timeout: 120000 },
      );
      setSpellIssues(data.issues || []);
      setSpellOpen(true);
      toast.success(
        data.issue_count === 0
          ? 'Clean — no issues found.'
          : `${data.issue_count} issue${data.issue_count === 1 ? '' : 's'} flagged.`,
      );
    } catch (err) {
      toast.error(`Spell-check failed: ${err?.response?.data?.detail || err.message || 'unknown'}`);
    } finally {
      setSpellChecking(false);
    }
  }, [project, chapter, isDemo, recordLock]);

  return { spellChecking, spellIssues, spellOpen, setSpellOpen, runSpellCheck };
}
